module.exports = __webpack_public_path__ + "img/abstract-shapes-20.67890567.svg";